import {MutationTree} from "vuex";

export const mutations: MutationTree<any> = {

    setLocalesLoading(state: any, payload: boolean) {
        state.localesLoading = payload;
    },

    setLocales(state:any, payload: any) {
        state.locales = payload;
    },

    resetLocalesCache(state:any) {
        state.localesExpire = null;
    }
};
